 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];

 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		// chunk prefetching for javascript
 		prefetchChunks.forEach(function(chunkId) {
 			if(installedChunks[chunkId] === undefined) {
 				installedChunks[chunkId] = null;
 				var link = document.createElement('link');

 				if (__webpack_require__.nc) {
 					link.setAttribute("nonce", __webpack_require__.nc);
 				}
 				link.rel = "prefetch";
 				link.as = "script";
 				link.href = jsonpScriptSrc(chunkId);
 				document.head.appendChild(link);
 			}
 		});
 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"c68dec1","1":"ab22e7b","2":"1f300a3","3":"f83f84f","4":"4fc77b8","5":"1480872","6":"91df191","7":"b14dac2","8":"1998c3f","9":"b993bc5","10":"055bfd9","11":"f0100e8","12":"ae6450c","13":"ebabba7","14":"2432796","16":"83b8fcc","17":"66d5cb2","18":"f396e36","19":"efff824","20":"be45cac","21":"2804e93","22":"bf87dc0","23":"67741c4","24":"9a6837f","25":"0cd4814","26":"3a100dc","27":"b427cfe","28":"48983ae","29":"02c852e","30":"467aebe","31":"d20642b","32":"af26240","33":"a008999","34":"79d1fd8","35":"393a4ba","36":"b67cb40","37":"4b4b9d2","38":"1e9ddac","39":"eb15835","40":"552c7e6","41":"4aa08d1","42":"b34ebda","43":"6475714","44":"edc354a","45":"b0ab244","46":"4ee84b6","47":"ead882d","48":"3e89760","49":"8d5b2a5","50":"f8304b4","51":"7c3e212","52":"55d074b","53":"c12041e","54":"c4f10c7","55":"54c2633","56":"3e935b7","57":"0773d49","58":"03274bd","59":"36af309","60":"2aa1ab4","61":"dd1a930","62":"4fad25f","63":"c7d9163","64":"7e06c11","65":"732f81e","66":"5921478","67":"1da1827","68":"ae2daf4","69":"636a84c","70":"01eef5d","71":"db5471e","72":"fe5972e","73":"1030aa9","74":"870b655","75":"4f2b950","76":"7946ccf","77":"6e5e87f","78":"03204d7","79":"5bc1d95","80":"b98f58b","81":"b990558","82":"6500c6e","83":"0481540","84":"f04e1d0","85":"f002212","86":"1001c03","87":"b82fa0e","88":"c205554","89":"273632e","90":"eefc3fc","91":"01b0477","92":"5852df4","93":"f868372","94":"33c0c07","95":"567a909","96":"099cc8c","97":"b8fbd51","98":"9131b15","99":"1f9391d","100":"25f4fad","101":"7626032","102":"cd9ac82","103":"3256e96","104":"4f6a8bc","105":"b93a8bf","106":"7663306","107":"72e3e8e","108":"6c5c5ed","109":"8f9578b","110":"102d833","111":"04ecada","112":"0ad9d87","113":"14dda22","114":"8e6ac2c","115":"63859e2","116":"bc6fe30","117":"464c3d9","118":"f94e100","119":"477de41","120":"005add4","121":"dddf013","122":"9622a20","123":"5bb6e22","124":"7b1e193","125":"920918a","126":"706e653","127":"be0731a","128":"0187ca3","129":"afbfa43","130":"6002149","131":"2653945","132":"f276c9c","133":"fe8633e","134":"a02fb4f","135":"70386cf","136":"26ff405","137":"b8073d9","138":"ca2ef40","139":"53de88f","140":"802ae9f","141":"7c80c29","142":"98e1363","143":"508a677","144":"f66048d","145":"78fdce7","146":"206986a","147":"94cf424","148":"39b331e","149":"64451b8","150":"77fd866","151":"b684a4c","152":"953b2d1","153":"6867268","154":"43c35c8","155":"b81b548","156":"97861c1","157":"6a1dea5","158":"eedd608","159":"e9750a4","160":"a8b6e38","161":"c30b251","162":"3e41a56","163":"d32f42a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// extract-css-chunks-webpack-plugin CSS loading
 		var supportsPreload = (function() { try { return document.createElement("link").relList.supports("preload"); } catch(e) { return false; }}());
 		var cssChunks = {"34":1,"41":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + {"0":"31d6cfe","1":"31d6cfe","2":"31d6cfe","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"31d6cfe","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","14":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"31d6cfe","26":"31d6cfe","27":"31d6cfe","28":"31d6cfe","29":"31d6cfe","30":"31d6cfe","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"ff38b4a","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"31d6cfe","40":"31d6cfe","41":"c1db75a","42":"31d6cfe","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"31d6cfe","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"31d6cfe","51":"31d6cfe","52":"31d6cfe","53":"31d6cfe","54":"31d6cfe","55":"31d6cfe","56":"31d6cfe","57":"31d6cfe","58":"31d6cfe","59":"31d6cfe","60":"31d6cfe","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe","66":"31d6cfe","67":"31d6cfe","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe","75":"31d6cfe","76":"31d6cfe","77":"31d6cfe","78":"31d6cfe","79":"31d6cfe","80":"31d6cfe","81":"31d6cfe","82":"31d6cfe","83":"31d6cfe","84":"31d6cfe","85":"31d6cfe","86":"31d6cfe","87":"31d6cfe","88":"31d6cfe","89":"31d6cfe","90":"31d6cfe","91":"31d6cfe","92":"31d6cfe","93":"31d6cfe","94":"31d6cfe","95":"31d6cfe","96":"31d6cfe","97":"31d6cfe","98":"31d6cfe","99":"31d6cfe","100":"31d6cfe","101":"31d6cfe","102":"31d6cfe","103":"31d6cfe","104":"31d6cfe","105":"31d6cfe","106":"31d6cfe","107":"31d6cfe","108":"31d6cfe","109":"31d6cfe","110":"31d6cfe","111":"31d6cfe","112":"31d6cfe","113":"31d6cfe","114":"31d6cfe","115":"31d6cfe","116":"31d6cfe","117":"31d6cfe","118":"31d6cfe","119":"31d6cfe","120":"31d6cfe","121":"31d6cfe","122":"31d6cfe","123":"31d6cfe","124":"31d6cfe","125":"31d6cfe","126":"31d6cfe","127":"31d6cfe","128":"31d6cfe","129":"31d6cfe","130":"31d6cfe","131":"31d6cfe","132":"31d6cfe","133":"31d6cfe","134":"31d6cfe","135":"31d6cfe","136":"31d6cfe","137":"31d6cfe","138":"31d6cfe","139":"31d6cfe","140":"31d6cfe","141":"31d6cfe","142":"31d6cfe","143":"31d6cfe","144":"31d6cfe","145":"31d6cfe","146":"31d6cfe","147":"31d6cfe","148":"31d6cfe","149":"31d6cfe","150":"31d6cfe","151":"31d6cfe","152":"31d6cfe","153":"31d6cfe","154":"31d6cfe","155":"31d6cfe","156":"31d6cfe","157":"31d6cfe","158":"31d6cfe","159":"31d6cfe","160":"31d6cfe","161":"31d6cfe","162":"31d6cfe","163":"31d6cfe"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if((tag.rel === "stylesheet" || tag.rel === "preload") && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = supportsPreload ? "preload": "stylesheet";
 				supportsPreload ? linkTag.as = "style" : linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0]; head.appendChild(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 				if(supportsPreload) {
 					var execLinkTag = document.createElement("link");
 					execLinkTag.href =  __webpack_require__.p + "css/" + {"0":"31d6cfe","1":"31d6cfe","2":"31d6cfe","3":"31d6cfe","4":"31d6cfe","5":"31d6cfe","6":"31d6cfe","7":"31d6cfe","8":"31d6cfe","9":"31d6cfe","10":"31d6cfe","11":"31d6cfe","12":"31d6cfe","13":"31d6cfe","14":"31d6cfe","16":"31d6cfe","17":"31d6cfe","18":"31d6cfe","19":"31d6cfe","20":"31d6cfe","21":"31d6cfe","22":"31d6cfe","23":"31d6cfe","24":"31d6cfe","25":"31d6cfe","26":"31d6cfe","27":"31d6cfe","28":"31d6cfe","29":"31d6cfe","30":"31d6cfe","31":"31d6cfe","32":"31d6cfe","33":"31d6cfe","34":"ff38b4a","35":"31d6cfe","36":"31d6cfe","37":"31d6cfe","38":"31d6cfe","39":"31d6cfe","40":"31d6cfe","41":"c1db75a","42":"31d6cfe","43":"31d6cfe","44":"31d6cfe","45":"31d6cfe","46":"31d6cfe","47":"31d6cfe","48":"31d6cfe","49":"31d6cfe","50":"31d6cfe","51":"31d6cfe","52":"31d6cfe","53":"31d6cfe","54":"31d6cfe","55":"31d6cfe","56":"31d6cfe","57":"31d6cfe","58":"31d6cfe","59":"31d6cfe","60":"31d6cfe","61":"31d6cfe","62":"31d6cfe","63":"31d6cfe","64":"31d6cfe","65":"31d6cfe","66":"31d6cfe","67":"31d6cfe","68":"31d6cfe","69":"31d6cfe","70":"31d6cfe","71":"31d6cfe","72":"31d6cfe","73":"31d6cfe","74":"31d6cfe","75":"31d6cfe","76":"31d6cfe","77":"31d6cfe","78":"31d6cfe","79":"31d6cfe","80":"31d6cfe","81":"31d6cfe","82":"31d6cfe","83":"31d6cfe","84":"31d6cfe","85":"31d6cfe","86":"31d6cfe","87":"31d6cfe","88":"31d6cfe","89":"31d6cfe","90":"31d6cfe","91":"31d6cfe","92":"31d6cfe","93":"31d6cfe","94":"31d6cfe","95":"31d6cfe","96":"31d6cfe","97":"31d6cfe","98":"31d6cfe","99":"31d6cfe","100":"31d6cfe","101":"31d6cfe","102":"31d6cfe","103":"31d6cfe","104":"31d6cfe","105":"31d6cfe","106":"31d6cfe","107":"31d6cfe","108":"31d6cfe","109":"31d6cfe","110":"31d6cfe","111":"31d6cfe","112":"31d6cfe","113":"31d6cfe","114":"31d6cfe","115":"31d6cfe","116":"31d6cfe","117":"31d6cfe","118":"31d6cfe","119":"31d6cfe","120":"31d6cfe","121":"31d6cfe","122":"31d6cfe","123":"31d6cfe","124":"31d6cfe","125":"31d6cfe","126":"31d6cfe","127":"31d6cfe","128":"31d6cfe","129":"31d6cfe","130":"31d6cfe","131":"31d6cfe","132":"31d6cfe","133":"31d6cfe","134":"31d6cfe","135":"31d6cfe","136":"31d6cfe","137":"31d6cfe","138":"31d6cfe","139":"31d6cfe","140":"31d6cfe","141":"31d6cfe","142":"31d6cfe","143":"31d6cfe","144":"31d6cfe","145":"31d6cfe","146":"31d6cfe","147":"31d6cfe","148":"31d6cfe","149":"31d6cfe","150":"31d6cfe","151":"31d6cfe","152":"31d6cfe","153":"31d6cfe","154":"31d6cfe","155":"31d6cfe","156":"31d6cfe","157":"31d6cfe","158":"31d6cfe","159":"31d6cfe","160":"31d6cfe","161":"31d6cfe","162":"31d6cfe","163":"31d6cfe"}[chunkId] + ".css";
 					execLinkTag.rel = "stylesheet";
 					execLinkTag.type = "text/css";
 					document.body.appendChild(execLinkTag);
 				}
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-static.ecosia.org/web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 204);
